export default {
  withdraw: {
    title: 'Retirar',
    subtitle: 'Rápido, seguro y cómodo',
    secureEncrypted: 'Seguro y Cifrado',
    fiatOrCash: 'Fiat/Efectivo',
    processing: 'Procesando...',
    select: 'Seleccionar',
    withdrawCurrency: 'Moneda de Retiro',
    chooseNetwork: 'Elegir Red',
    channel: 'Canal',
    withdrawalAddress: 'Dirección de Retiro',
    pixKeyType: 'Tipo de Clave PIX',
    accountNumber: 'Número de Cuenta',
    enterAccountNumber: 'Introduce el número de tu cuenta',
    accountName: 'Nombre de la Cuenta',
    enterAccountName: 'Introduce el nombre del titular de la cuenta',
    pixKey: 'Clave PIX',
    enterPixKey: 'Introduce tu clave PIX',
    cpf: 'CPF',
    enterCpf: 'Introduce el CPF',
    bankName: 'Nombre del Banco',
    enterBankName: 'Introduce el nombre del banco',
    branch: 'Sucursal',
    enterBranch: 'Introduce la sucursal (opcional)',
    phone: 'Teléfono',
    enterPhone: 'Introduce el teléfono (opcional)',
    email: 'Correo electrónico',
    enterEmail: 'Introduce el correo electrónico (opcional)',
    available: 'Retirable',
    amountPlaceholder: 'Importe ({unit})',
    min: 'Mín',
    max: 'Máx',
    totalWithdrawalAmount: 'Importe total del retiro:',
    fee: 'Comisión:',
    withdrawalAmount: 'Importe del Retiro:',
    fundsSafeTitle: 'Tus fondos están seguros con nosotros',
    fundsSafeDesc: 'Usamos seguridad líder del sector para proteger tus transacciones e información personal.',
    enterWithdrawalAddress: 'Por favor introduce la dirección de retiro',
    enterAccountNumberRequired: 'Por favor introduce el número de tu cuenta',
    selectChannelRequired: 'Por favor selecciona un canal',
    enterAccountNameRequired: 'Por favor introduce el nombre del titular de la cuenta',
    selectPixKeyTypeRequired: 'Por favor selecciona el tipo de clave PIX',
    enterCpfRequired: 'Por favor introduce el CPF',
    enterValidAmount: 'Por favor introduce un importe válido',
    minWithdrawal: 'Retiro mínimo: {amount} {unit}',
    maxWithdrawal: 'Retiro máximo: {amount} {unit}',
    insufficientBalance: 'Saldo disponible insuficiente',
    withdrawalRejected: 'Retiro rechazado',
    submittedPendingReview: 'Retiro enviado, pendiente de revisión',
    submittedPayoutInProgress: 'Retiro enviado, pago en proceso',
    withdrawalFailed: 'Retiro fallido',
    withdrawalFailedRetry: 'Retiro fallido, por favor inténtalo de nuevo',
  },
};
